/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiProfile.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-profile";

export class AutogenModelEdiProfile<RowType extends ModelRow> extends Endpoint<RowType, RowEdiProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiProfile extends ModelRow<RowEdiProfileFields> {
	constructor(values?: Partial<RowEdiProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiProfileFields {
	ack_xmit_method: string;
	alt_partner_id: string;
	company_id: string;
	days_to_retain: number;
	direction: string;
	edi_comm_id: number;
	enf_batch_cont: string;
	enf_batch_cont_997: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	id: string;
	intercompany: string;
	next_batch: number;
	notes: string;
	partner_id: string;
	partner_name: string;
	process_priority: number;
	remove_doc: string;
	remove_file: string;
	remove_func_ack: string;
	send_func_ack: string;
	send_to_company: string;
	special_processing: string;
	st02_format: string;
	template_id: number;
	transaction_set: string;
	transaction_type: string;
	transmit_method: string;
	use_master_batch: string;
	version: string;
}

